export default function Settings() {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Settings</h1>
      <div className="card">
        <p className="text-gray-500">Settings coming soon...</p>
      </div>
    </div>
  )
}
